import { get, post } from "../ApiHelper/index";
import {
  TIEU_CHI_DANH_GIA,
  NHOM_THAM_CHIEU,
  THEM_TIEU_CHI_DANH_GIA,
  CAP_NHAT_TIEU_CHI_DANH_GIA,
} from "../apis/_index";

export const tieuchidanhgia_list = () => {
  return new Promise(async (resolve) => {
    return await get(TIEU_CHI_DANH_GIA)
      .then((res: any) => {
        resolve({
          status: true,
          data: res.data.Data,
        });
      })
      .catch((err: any) => {
        resolve({
          status: false,
          err: err,
        });
      });
  });
};

export const nhomThamChieu = () => {
  return new Promise(async (resolve) => {
    return await get(NHOM_THAM_CHIEU)
      .then((res: any) => {
        resolve({
          status: true,
          data: res.data.Data,
        });
      })
      .catch((err: any) => {
        resolve({
          status: false,
          err: err,
        });
      });
  });
};

export const tieuchidanhgia_create = (data: any) => {
  return new Promise(async (resolve) => {
    // console.log("tieuchidanhgia_create", data);
    return await post(THEM_TIEU_CHI_DANH_GIA, data)
      .then((res: any) => {
        resolve({
          status: true,
          data: res.data.Data,
        });
      })
      .catch((err: any) => {
        resolve({
          status: false,
          err: err,
        });
      });
  });
};

export const tieuchidanhgia_update = (data: any) => {
  return new Promise(async (resolve) => {
    // console.log("tieuchidanhgia_update", data);
    return await post(CAP_NHAT_TIEU_CHI_DANH_GIA, data)
      .then((res: any) => {
        resolve({
          status: true,
          data: res.data.Data,
        });
      })
      .catch((err: any) => {
        resolve({
          status: false,
          err: err,
        });
      });
  });
};
